import React, { useContext, useEffect, useRef, useState } from 'react';
import InputText from '../../../../components/inputComponents/InputText';
import DatePicker from '../../../../components/dateComponents/DatePicker';
import { ModalContext } from '../../../../components/contexts';

const Actv = ({
  textAreaRef,
  setIsFileModalOpen,
  valueList,
  controller,
  isReadOnly,
}) => {
  const part = 'actv';
  const actv = {
    actvNm: '',
    actvCn: '',
    bgngYmd: '',
    endYmd: '',
    atchFileId: '',
    fileList: [],
  };

  const { modalService } = useContext(ModalContext);

  const focusInput = useRef([]);
  const [focusOn, setFocusOn] = useState(true);
  const trigger = useRef(0);

  useEffect(() => {
    if (valueList[part]) {
      if (valueList[part].length === 0) {
        controller.append_btn(part, actv, setFocusOn);
      } else {
        setFocusOn(false);
      }
    }
  }, [valueList]);

  useEffect(() => {
    const lng = valueList[part] && valueList[part].length;
    if (focusOn && lng > 0 && trigger.current >= 2) {
      controller.focusData(part, focusInput);
      setFocusOn(false);
    }
    trigger.current++;
  }, [valueList[part]]);

  return (
    <>
      <h3>전문가 활동내역</h3>
      <div className="tbl-wrap">
        <table className="tbl col data scroll">
          <caption>
            전문가 심사 신청 활동내역의 활동명, 활동내용, 시작일, 종료일,
            증빙서류의 정보를 나타내는 표입니다.
          </caption>
          <colgroup>
            <col style={{ width: '25%' }} />
            <col style={{ width: '26%' }} />
            <col style={{ width: '19%' }} />
            <col style={{ width: '19%' }} />
            <col style={{ width: '11%' }} />
          </colgroup>
          <thead>
            <tr>
              <th scope="col">활동명</th>
              <th scope="col">활동내용</th>
              <th scope="col">시작일</th>
              <th scope="col">종료일</th>
              <th scope="col">증빙서류</th>
            </tr>
          </thead>
          <tbody>
            {valueList[part] &&
              valueList[part].map((row, rowIndex) => (
                <tr key={rowIndex}>
                  <td>
                    <label
                      ref={el => {
                        focusInput.current[rowIndex] = el;
                      }}
                      htmlFor={'actvNm' + rowIndex}
                      hidden
                    >
                      활동명
                    </label>
                    <InputText
                      id={'actvNm' + rowIndex}
                      model="actvNm"
                      maxLength={300}
                      value={row}
                      isReadonly={isReadOnly}
                      changeEvt={(model, value) => {
                        const updateItem = { ...row, [model]: value };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                    />
                  </td>
                  <td>
                    <textarea
                      aria-label="활동내용"
                      id={'actvCn' + rowIndex}
                      rows={1}
                      ref={el => {
                        textAreaRef.current.push(el);
                      }}
                      className="form-control sm notClamp notResize"
                      name="actvCn"
                      value={row.actvCn}
                      onChange={e => {
                        const updateItem = {
                          ...row,
                          [e.target.name]: e.target.value,
                        };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                      readOnly={isReadOnly}
                      maxLength={4000}
                    />
                  </td>
                  <td>
                    <DatePicker
                      id={'actvBgngYmd' + rowIndex}
                      model="bgngYmd"
                      value={row}
                      isReadonly={isReadOnly}
                      changeEvt={(model, value) => {
                        if (value.length > 8) return;
                        if (value.length === 8) {
                          if (controller.validationDate(value)) {
                            modalService.noticeAlert(
                              '시작일은 오늘보다 클 수 없습니다.'
                            );
                            value = '';
                          } else if (row.endYmd && value > row.endYmd) {
                            modalService.noticeAlert(
                              '종료일보다 클 수 없습니다.'
                            );
                            value = '';
                          }
                        }
                        const updateItem = { ...row, [model]: value };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                    />
                  </td>
                  <td>
                    <DatePicker
                      id={'actvEndYmd' + rowIndex}
                      model="endYmd"
                      value={row}
                      isReadonly={isReadOnly}
                      changeEvt={(model, value) => {
                        if (value.length > 8) return;
                        if (value.length === 8) {
                          if (value < row.bgngYmd) {
                            modalService.noticeAlert(
                              '시작일보다 작을 수 없습니다.'
                            );
                            value = '';
                          }
                        }
                        const updateItem = { ...row, [model]: value };
                        controller.updateList(part, rowIndex, updateItem);
                      }}
                    />
                  </td>
                  <td>
                    {isReadOnly &&
                      (row.fileList.length > 0 ? (
                        row.fileList.map((file, index) => (
                          <div key={index} style={{ cursor: 'pointer' }}>
                            <div
                              className="reduceFileName"
                              onClick={() => {
                                controller.downloadUploadedFile(file);
                              }}
                            >
                              {file.orgnflNm}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div>
                          <span>-</span>
                        </div>
                      ))}
                    {!isReadOnly && (
                      <button
                        type="button"
                        className="btn xsm secondary"
                        onClick={() => {
                          setIsFileModalOpen(true);
                          controller.settingRowInfo(part, row, rowIndex);
                        }}
                      >
                        첨부
                      </button>
                    )}
                  </td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
      {!isReadOnly && (
        <div className="btn-group">
          <button
            type="button"
            onClick={() => {
              controller.append_btn(part, actv, setFocusOn);
            }}
            className="btn xsm secondary"
          >
            추가
          </button>
          <button
            type="button"
            onClick={() => controller.delete_btn(part)}
            className="btn xsm secondary"
          >
            삭제
          </button>
        </div>
      )}
    </>
  );
};

export default Actv;
